var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverPortalMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 193,
    viewBox: "0 0 197 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19899_2392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-108.662 -33.786C-93.9315 -61.2381 150.194 -98.9795 196.125 -90.8812C242.056 -82.783 377.16 67.0893 398.896 101.473C368.971 118.215 213.781 172.662 170.731 182.511C127.171 192.476 100.575 161.376 43.8749 156.412C-12.825 151.449 -42.1138 204.91 -73.3937 166.261",
    fill: "url(#paint0_linear_19899_2392)",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19899_2392",
    x: -117.977,
    y: -91.9964,
    width: 521.073,
    height: 284.863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19899_2392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19899_2392",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19899_2392",
    x1: -32.5,
    y1: 137,
    x2: 177.55,
    y2: 198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2AC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#339FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverPortalMarketplace);
export default __webpack_public_path__ + "static/media/hover_portal_marketplace.68a7f2023b1fb3d1e4c111332adae5b8.svg";
export { ForwardRef as ReactComponent };